import { api } from "../../../api/api";

/**
 * Downloads an uploaded file (by its server key/path) and returns it as an
 * ArrayBuffer. Used to feed the `.msg` parser for already-uploaded files.
 */
export const fetchFileArrayBuffer = async (
  fileName: string | null,
): Promise<ArrayBuffer | null> => {
  if (!fileName) {
    return null;
  }

  const res = await api.post(
    "/general/download-files",
    {
      type: "",
      keys: [fileName],
    },
    {
      responseType: "arraybuffer",
    },
  );

  return res.data as ArrayBuffer;
};
